module.exports = __webpack_public_path__ + "static/media/curve-bottom-modified-right.b75b26ec.png";